import { ISelectMultiOption } from '@shared/components/Form';

// Options from a GET /router/settings dictionary (code → label), plus any selected value
// the dictionary lacks, so values from older configs stay selectable and readable.
export const toOptions = (
  dictionary: Record<string, string> = {},
  selected: string[] = [],
): ISelectMultiOption[] => {
  const options = Object.entries(dictionary).map(([value, label]) => ({ value, label }));
  const known = new Set(options.map(option => option.value));

  return [
    ...options,
    ...selected.filter(value => !known.has(value)).map(value => ({ value, label: value })),
  ];
};
